var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.504 14.24a.491.491 0 1 0 0 .982v-.983Zm-4.507-2.095v.491h.983v-.491h-.983Zm1.563-5.98h12.37v-.983H9.56v.982Zm12.95.58v6.914h.983V6.744h-.983Zm-.58 7.494h-9.426v.983h9.426v-.983ZM8.98 12.145v-5.4h-.983v5.4h.983Zm13.53 1.514c0 .32-.26.58-.58.58v.983c.863 0 1.563-.7 1.563-1.563h-.983Zm-.58-7.495c.32 0 .58.26.58.58h.983c0-.863-.7-1.562-1.563-1.562v.982ZM9.56 5.182c-.863 0-1.563.7-1.563 1.562h.983c0-.32.26-.58.58-.58v-.982Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.488 7.271h14.513v2.131H8.488zM18.16 12.067h3.225v1.066H18.16z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.983,
  d: "M19.418 14.812c-.34.665-.878 1.242-1.666 1.242-.826 0-1.037-.632-.998-1.336M16.68 14.613c-.185 1.156-.57 2.419-1.572 2.419-1.258 0-1.414-1.263-1.272-2.419M11.188 15.371c.03.369.312.683 1.161.683 1.053 0 1.338-.76 1.467-1.303"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.983,
  d: "m.673 17.357 4.981.282c1.059-.016 3.405-.468 4.323-2.143 1.559.196 5.406-2.365 4.524-3.729-.693-1.071-1.636-.832-2.294-.646-.876.248-4.098 1.306-5.599 1.804M.97 9.67l5.226-3.014c.305-.32 1.053-.942 1.608-.873.36.046.632.155.808.255"
})));
export default SvgIconPayment;